<template>
  <div class="doctor-salary-bill-page">
    <!-- 页面标题 -->
    <div class="page-header">
      <h2>
        <i class="el-icon-arrow-left mr16" @click="goBack"></i>
        {{ searchForm.condition.salaryMonth }} 医生薪酬账单明细
      </h2>
       <a href="https://bfbixsute0.feishu.cn/sheets/VAjmsow0shcUGktlUEjckQXwnsh?from=from_copylink" target="_blank">查看统计规则</a>
    </div>

    <!-- Tab栏 -->
    <div class="tab-container">
      <div class="tab-group">
        <button class="tab-item" :class="{ active: activeTab === 'monthly' }"
          @click="activeTab = 'monthly'; handleTabChange()">
          月薪合计
        </button>
        <button class="tab-item" :class="{ active: activeTab === 'column' }"
          @click="activeTab = 'column'; handleTabChange()">
          分馆统计
        </button>
      </div>
    </div>

    <!-- 搜索区域 -->
    <div class="search-area">
      <el-form class="search-form" :model="searchForm" inline size="small">
        <div>
          <el-form-item label="医生姓名">
            <el-input v-model="searchForm.condition.doctorName" placeholder="请输入医生姓名" clearable />
          </el-form-item>
          <el-form-item label="员工编号">
            <el-input v-model="searchForm.condition.userCode" placeholder="请输入员工编号" clearable />
          </el-form-item>
          <el-form-item label="是否达到保底工资">
            <el-select v-model="searchForm.condition.reachGuarantee" placeholder="不限" clearable>
              <el-option label="是" :value="true" />
              <el-option label="否" :value="false" />
            </el-select>
          </el-form-item>
          <el-form-item label="医馆名称" v-if="activeTab === 'column'">
            <el-select v-model="searchForm.condition.deptId" placeholder="请选择医馆名称" clearable>
              <el-option v-for="item in deptList" :key="item.deptId" :label="item.deptName" :value="item.deptId" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-form-item>
        </div>
        <el-form-item class="export-item">
          <el-button type="primary" plain @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 - 月新合计 -->
    <el-table class="data-table" :data="tableData" border :cell-style="{ borderColor: '#dcdfe6' }" height="560"
      :header-cell-style="{ background: '#f5f7fa', borderColor: '#dcdfe6', color: '#333333' }">
      <el-table-column prop="doctorName" label="医生姓名" width="120" />
      <el-table-column prop="userCode" label="员工编号" width="120" />
      <el-table-column prop="teamName" label="所属工作室" width="140" />
      <el-table-column prop="deptName" label="医馆名称" width="100" v-if="activeTab === 'column'" />
      <el-table-column prop="payableSalaryAmount" label="应发工资" width="120" align="right" />
      <el-table-column prop="commissionSalaryAmount" label="提成工资" width="120" align="right" />
      <el-table-column prop="guaranteeSalaryPayableAmount" label="应发保底" width="120" align="right" />
      <el-table-column prop="certificateSubsidyAmount" label="证书补贴" width="120" align="right" />
      <el-table-column prop="trafficSubsidyAmount" label="交通补贴" width="120" align="right" />
      <el-table-column prop="otherFixedSubsidyAmount" label="其它固定补贴" width="140" align="right" />
      <el-table-column prop="registerCommissionAmount" label="挂号费提成" width="120" align="right" />
      <el-table-column prop="registerTotalAmount" label="挂号费总额" width="120" align="right" />
      <el-table-column prop="meituanRegisterCommissionAmount" label="美团挂号费提成" width="140" align="right" />
      <el-table-column prop="meituanRegisterTotalAmount" label="美团挂号费总额" width="140" align="right" />
      <el-table-column prop="processCommissionAmount" label="加工费提成" width="120" align="right" />
      <el-table-column prop="processSalesAmount" label="加工费销售业绩" width="140" align="right" />
      <el-table-column prop="clinicHerbCommissionAmount" label="门诊饮片提成" width="140" align="right" />
      <el-table-column prop="clinicHerbSalesAmount" label="门诊饮片销售业绩" width="160" align="right" />
      <el-table-column prop="clinicGranuleCommissionAmount" label="门诊颗粒提成" width="140" align="right" />
      <el-table-column prop="clinicGranuleSalesAmount" label="门诊颗粒销售业绩" width="160" align="right" />
      <el-table-column prop="onlineHerbCommissionAmount" label="网诊饮片提成" width="140" align="right" />
      <el-table-column prop="onlineHerbSalesAmount" label="网诊饮片销售业绩" width="160" align="right" />
      <el-table-column prop="onlineGranuleCommissionAmount" label="网诊颗粒提成" width="140" align="right" />
      <el-table-column prop="onlineGranuleSalesAmount" label="网诊颗粒销售业绩" width="160" align="right" />
      <el-table-column prop="physioOrderCommissionAmount" label="理疗开单提成" width="160" align="right" />
      <el-table-column prop="physioOrderSalesAmount" label="理疗开单业绩" width="160" align="right" />
      <el-table-column prop="physioExecuteCommissionAmount" label="理疗执行提成" width="160" align="right" />
      <el-table-column prop="physioExecuteSalesAmount" label="理疗执行业绩" width="160" align="right" />
      <el-table-column prop="retailCommissionAmount" label="零售提成" width="160" align="right" />
      <el-table-column prop="retailSalesAmount" label="零售业绩" width="160" align="right" />
      <el-table-column prop="shouldVisitCount" label="应坐诊次数" width="160" align="right" />
      <el-table-column prop="actualVisitCount" label="实际坐诊次数" width="160" align="right" />
    </el-table>
    <!-- 分页 -->
    <div class="page-wrap">
      <el-pagination background layout="sizes,total, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 40]"
        :page-size="searchForm.pageSize" :current-page="searchForm.pageIndex" :total="total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
import { doctorSalaryBillPage, doctorSalaryBillDeptPage, salaryDetailExport, salaryDetailDeptExport } from '@/api/salary';
import { getActiveDeptList } from '@/api/dept'

export default {
  name: 'DoctorSalaryBill',
  data() {
    return {
      activeTab: 'monthly',
      searchForm: {
        condition: {
          salaryMonth: '',
          doctorName: '',
          userCode: '',
          deptId: ''
        },
        pageIndex: 1,
        pageSize: 10
      },
      tableData: [],
      total: 0,
      deptList: []
    };
  },
  mounted() {
    const month = this.$route.query.salaryMonth || this.$moment().format('YYYY-MM');
    this.searchForm.condition.salaryMonth = month;
    this.handleSearch();
    this.getActiveDeptList();
  },
  methods: {
    async getActiveDeptList() {
      let { code, data } = await getActiveDeptList()
      if (code === 200) {
        this.deptList = data || [];
      }
    },
    // Tab切换处理
    handleTabChange() {
      this.searchForm.pageIndex = 1;
      this.handleSearch();
    },
    handleSearch() {
      this.searchForm.pageIndex = 1;
      if (this.activeTab === 'column') {
        this.getSalaryDeptList();
      } else {
        this.getSalaryList();
      }
    },
    handleReset() {
      this.searchForm = {
        condition: {
          doctorName: '',
          userCode: '',
          deptId: '',
          salaryMonth: this.$route.query.salaryMonth
        },
        pageIndex: 1,
        pageSize: 10
      };
      this.handleSearch();
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.searchForm.pageIndex = 1;
      if (this.activeTab === 'column') {
        this.getSalaryDeptList();
      } else {
        this.getSalaryList();
      }
    },
    handleCurrentChange(pageIndex) {
      this.searchForm.pageIndex = pageIndex;
      if (this.activeTab === 'column') {
        this.getSalaryDeptList();
      } else {
        this.getSalaryList();
      }
    },
    handleExport() {
      if (this.activeTab === 'column') {
        salaryDetailDeptExport({ ...this.searchForm.condition }, { name: '医生薪酬账单明细' }).then(res => {
          this.$message.success('导出成功');
        })
      } else {
        salaryDetailExport({ ...this.searchForm.condition, deptId: 'all' }, { name: '医生薪酬账单明细' }).then(res => {
          this.$message.success('导出成功');
        })
      }
    },
    getSalaryList() {
      doctorSalaryBillPage(this.searchForm).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      })
    },
    getSalaryDeptList() {
      doctorSalaryBillDeptPage(this.searchForm).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      })
    },
    goBack() {
      this.$router.back();
    }
  }
};
</script>

<style lang="less" scoped>
.doctor-salary-bill-page {
  padding: 16px;
  background: #ffffff;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  .page-header {
    margin-bottom: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    h2 {
      font-size: 18px;
      font-weight: 600;
      color: #333;
      margin: 0;
    }
  }

  .tab-container {
    margin-bottom: 12px;

    .tab-group {
      display: flex;
      gap: 16px;

      .tab-item {
        padding: 8px 32px;
        font-size: 14px;
        font-weight: 500;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        background: #ffffff;
        color: #666666;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          border-color: #409eff;
          color: #409eff;
        }

        &.active {
          background: #409eff;
          border-color: #409eff;
          color: #ffffff;
        }
      }
    }
  }

  .search-area {
    margin-bottom: 12px;
    padding: 12px 16px;
    background: #f5f7fa;
    border-radius: 4px;

    .search-form {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;

      /deep/ .el-form-item {
        margin-bottom: 0;

        &.export-item {
          margin-right: 0;
        }
      }
    }
  }

  .data-table {
    width: 100%;
  }

  .page-wrap {
    display: flex;
    justify-content: flex-end;
    padding: 12px 16px;
    background: #f5f7fa;
    border-top: 1px solid #e4e7ed;
  }
}
</style>
